// test739
(739 && 0);
